import { isTeacherAccount } from "./userAccess";

/**
 * Where every new student account is sent: the free-trial wizard opens with
 * the profile step (phone, country / time zone, birthdate and the rest) for an
 * account that is still missing those fields, then carries straight on into
 * the trial questions. Both sign-up routes need it - the email form only
 * collects name, email and password, and Google supplies little more.
 */
export const FREE_TRIAL_PATH = "/book/free-trial";

/**
 * Whether this account still has to fill in its profile. Read strictly as
 * `=== false`: the backend only ever sends `false` for an account that really
 * is incomplete, so a user object that predates the field never qualifies.
 * Teacher accounts are admin-provisioned with a full profile and never do.
 */
export function needsProfileCompletion(user: unknown): boolean {
  if (typeof user !== "object" || user === null) {
    return false;
  }

  return (
    (user as { profile_completed?: unknown }).profile_completed === false &&
    !isTeacherAccount(user)
  );
}

/**
 * Whether an already region+locale-prefixed internal path (e.g.
 * `/egy/en/book/free-trial?category_id=3`) is the free-trial page. Used to keep
 * a return path that already points there, along with its query string,
 * instead of replacing it with the bare page.
 */
export function isFreeTrialPath(path: string | null | undefined): boolean {
  if (!path) {
    return false;
  }

  const [pathname] = path.split(/[?#]/);

  return pathname.replace(/\/+$/, "").endsWith(FREE_TRIAL_PATH);
}
